/**
 * The agent page's own route (slice 1e spec §3). `['agent', slug]`; a `turn`
 * hub event invalidates every agent's (C§10), so This week follows its replies.
 */
import { useQuery } from "@tanstack/react-query";
import { api } from "../../app/api";
import type { AgentPage } from "./agent-view";

export const agentsKey = ["agent"] as const;
export const agentKey = (slug: string) => ["agent", slug] as const;

export function useAgentPage(slug: string) {
  return useQuery({
    queryKey: agentKey(slug),
    queryFn: () => api<AgentPage>("GET", `/api/agents/${encodeURIComponent(slug)}`),
  });
}
